export const contactTypes = {
  SEND_EMAIL: "contact/SEND_EMAIL",
  SEND_EMAIL_SUCCESS: "contact/SEND_EMAIL_SUCCESS",
};

export const sendEmail = (payload) => ({
  type: contactTypes.SEND_EMAIL,
  payload,
});
